<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Add Messaging Bundle</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span class="hubtiger-close"></span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="BundleForm" (ngSubmit)="saveBundle(BundleForm.value)">
        <div class="row margin-top-8">
            <div class="col-md-2 label">*Description:</div>
            <div class="col-md-10">
                <div class="p-inputgroup">
                    <input type="text" pInputText formControlName="packageDescription"
                           placeholder="Package description e.g. 1000 SMS Bundle"/>
                </div>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-2 label">*Country:</div>
            <div class="col-md-4">
                <div class="p-inputgroup">
                    <p-dropdown [options]="countries" formControlName="country" placeholder="Country"
                                (onChange)="updateFields($event)"></p-dropdown>
                </div>
            </div>
            <div class="col-md-2 label">*Locale:</div>
            <div class="col-md-4">
                <div class="p-inputgroup">
                    <input type="text" pInputText formControlName="locale" [disabled]="true" maxlength="5"
                           placeholder="Locale e.g. EN-ZA"/>
                </div>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-2 label">*Currency:</div>
            <div class="col-md-4">
                <div class="p-inputgroup">
                    <input type="text" pInputText formControlName="currency" maxlength="3" placeholder="e.g. ZAR"/>
                </div>
            </div>
            <div class="col-md-2 label">*Currency Symbol:</div>
            <div class="col-md-4">
                <div class="p-inputgroup">
                    <input type="text" pInputText formControlName="currencySymbol" maxlength="3" placeholder="e.g. R"/>
                </div>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-2 label">*Credits:</div>
            <div class="col-md-4">
                <div class="p-inputgroup">
                    <input type="number" pInputText formControlName="credits" placeholder="e.g. 1000"/>
                </div>
            </div>
            <div class="col-md-2 label">*Bundle Cost:</div>
            <div class="col-md-4">
                <div class="p-inputgroup">
                    <input type="number" pInputText formControlName="amount" placeholder="e.g. 149.99 in Currency"/>
                </div>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-2 label">*Bundle Type:</div>
            <div class="col-md-4">
                <p-radioButton name="BundleType" value="3" formControlName="typeID" label="SMS"></p-radioButton>
            </div>
        </div>

        <div class="row margin-top-16">
            <div class="col-md-9"></div>
            <div class="col-md-3">
                <button pButton type="submit" class="p-button-raised full-width" label="Add Bundle Package"
                        [disabled]="!BundleForm.valid || busy"></button>
            </div>
        </div>

    </form>
</div>

<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
